<template>
  <div class="main">
    <Anonce v-if="site_settings.has_anonce == 1" />
    <h2>Кабинет ученика</h2>
    <!-- <router-link class="contest-btn" to="/matrius">
      <i class="fas fa-award"></i> Битва Матриуса
    </router-link> -->
    <ul class="uk-child-width-1-4@s uk-grid-match uk-flex-center uk-grid-small" uk-grid>
      <li>
        <router-link to="/trainers">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat1.png'" alt="">
            </div>
            <p>Тренажеры</p>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/matrius-news">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img src="/themes/genius/assets/img/logo.png" alt="">
            </div>
            <p>Новости Матриуса</p>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/classes">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat2.png'" alt="">
            </div>
            <p>Мои классы</p>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/stats">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat3.png'" alt="">
            </div>
            <p>Статистика</p>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/scores">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat4.png'" alt="">
            </div>
            <p>Достижения</p>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/homework">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat5.png'" alt="">
            </div>
            <p>Домашнее задание</p>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/lessons">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat6.png'" alt="">
            </div>
            <p>Мои занятия</p>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/materials">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat7.png'" alt="">
            </div>
            <p>Материалы</p>
          </div>
        </router-link>
      </li>
      
<!--      <li v-if="!user.is_outside">
        <router-link to="/shop">
          <div class="maincontent__item">
            <div class="maincontent__ico">
              <img :src="'/storage/app/media/categories/cat8.png'" alt="">
            </div>
            <p>Магазин подарков</p>
          </div>
        </router-link>
      </li>-->
      
      <!--<li>
        <router-link to="/rt">
          <div class="maincontent__item">
          <div class="maincontent__ico">
              <img src="" alt="">
            </div>
            <p>РТ - тесты <br><small>Совершенно секретно! Нажимать только в случае крайней необходимости!</small></p>
          </div>
        </router-link>
      </li>-->
    </ul>
  </div>
</template>

<script>
import Anonce from './Anonce'
import { mapGetters } from 'vuex'
export default {
  name: "maincomponent",
  components: {
    Anonce
  },
  inject: ['site_settings'],
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  props: {
    items: ''
  },
  methods: {}
}
</script>